import { generatePath } from 'react-router-dom'
import { CompanyTag } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { UnsubscribeRequestKey } from 'api/Trading-Accounts/Types/UnsubscribeRequestDto'
import { HeaderSortCell } from 'components/Filter'
import { Link } from 'components/Link'
import { formatLocalDateUTC } from 'utils/date'
import { links } from 'utils/featureToggles'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const unsubscribeRequestColumns: GridColumn[] = [
  {
    title: 'Reference',
    field: UnsubscribeRequestKey.reference,
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
    sortable: false,
  },
  {
    title: 'Description',
    field: UnsubscribeRequestKey.description,
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
    sortable: false,
  },
  {
    title: 'Client',
    field: UnsubscribeRequestKey.client,
    minResizableWidth: 120,
    width: 120,
    show: true,
    cell: (props: GridCellProps) => (
      <td style={{ color: 'var(--link)', textDecoration: 'underline', width: 'auto' }}>
        <Link
          to={{
            pathname: generatePath(links.recordsClients.detailsUrl as string, {
              id: props.dataItem.client.id,
              slug: 'details',
            }),
          }}
        >
          {props.dataItem.client.name}
        </Link>
      </td>
    ),
    filter: 'text',
    sortable: false,
  },
  {
    title: 'Subscription Name',
    field: UnsubscribeRequestKey.subscriptionName,
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
    sortable: false,
  },
  {
    title: 'Country',
    field: UnsubscribeRequestKey.country,
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
    sortable: false,
  },
  {
    title: 'Status',
    field: UnsubscribeRequestKey.status,
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
    sortable: false,
  },
  {
    title: 'Company',
    field: UnsubscribeRequestKey.tickmillCompany,
    minResizableWidth: 120,
    width: 120,
    show: true,
    cell: (props: GridCellProps) => (
      <td>
        <CompanyTag id={props.dataItem.tickmillCompany.id}>
          {props.dataItem.tickmillCompany.name}
        </CompanyTag>
      </td>
    ),
    filter: 'text',
    sortable: false,
  },
  {
    title: 'Date Created',
    field: UnsubscribeRequestKey.createdDate,
    minResizableWidth: 120,
    width: 120,
    show: true,
    cell: (props: GridCellProps) => <td>{formatLocalDateUTC(props.dataItem.createdDate, true)}</td>,
    filter: 'text',
    headerCell: HeaderSortCell,
  },

  {
    title: 'Date Updated',
    field: UnsubscribeRequestKey.updatedDate,
    minResizableWidth: 120,
    width: 120,
    show: true,
    cell: (props: GridCellProps) => <td>{formatLocalDateUTC(props.dataItem.updatedDate, true)}</td>,
    filter: 'text',
    headerCell: HeaderSortCell,
  },
]
